var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8052 19.377H15.2291V17.7415H19.8052V13.1186H21.4238V17.7415H26V19.377H21.4238V24H19.8052V19.377ZM21.797 6.58771V8.86166H20.1784V1.63507H2.99969C2.23798 1.63507 1.61904 2.26146 1.61904 3.03104V18.4759L2.60621 17.9434C3.06038 17.699 3.6026 17.699 4.05595 17.9443L5.89051 18.9312L7.65243 17.9434C8.10579 17.6998 8.64807 17.6998 9.1003 17.9434L10.9344 18.9312L11.6232 20.3737C11.169 20.619 10.6268 20.619 10.1737 20.3746L8.33885 19.3868L6.57769 20.3746C6.35034 20.4964 6.10265 20.5577 5.85337 20.5577C5.6041 20.5577 5.35557 20.4964 5.12822 20.3737L3.29415 19.3868L2.26307 19.9812C1.78153 20.2412 1.21409 20.2265 0.747141 19.9428C0.279418 19.6589 0 19.1604 0 18.6093V3.03123C0 1.35981 1.3452 0 2.99953 0H20.9871V0.818046V0.000560382C21.9494 0.000560382 22.7911 0.356192 23.4193 1.02915C24.9409 2.65949 24.7823 5.68988 24.775 5.81828L24.7306 6.58762L21.797 6.58771ZM21.797 4.95246V1.81337C21.9599 1.89577 22.1067 2.0072 22.2395 2.14874C22.8747 2.82825 23.0931 4.07009 23.15 4.95247L21.797 4.95246ZM4.91243 6.856H16.8833V5.22047H4.91243V6.856ZM4.91243 10.4969H16.8833V8.86166H4.91243V10.4969ZM4.91243 14.1373H13.3571V12.502H4.91243V14.1373Z",
    fill: "#00FF3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrder);
export default __webpack_public_path__ + "static/media/new-order.dfb4b63a8e3bead1eecc8a09212f9520.svg";
export { ForwardRef as ReactComponent };